
export const webhooks = {
  contactForm: 'https://hooks.zapier.com/hooks/catch/3854790/lmoepc/',
  emailNewsletter: 'https://hooks.zapier.com/hooks/catch/3854790/eolzec/',
  prayerDiary: 'https://hooks.zapier.com/hooks/catch/3854790/eokdvn/',
};